import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    searchKeyword: "",
    featured: false
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        searchBook: (state, action) => {
            state.searchKeyword = action.payload
        },
        filterByFeatured: (state, action) => {
            state.featured = action.payload
        }
    },
});

export const { searchBook, filterByFeatured } = filterSlice.actions;
export default filterSlice.reducer;
